import { ReportState } from '../state';

export { toggleSigned, setSigned } from './set-signed';
export { setInput } from './set-inputs';

export const clearReportUrls = (state: ReportState) => {
  state.draftReport.data = undefined;
  state.finalReport.data = undefined;
};
